import * as Yup from "yup";

export const CategorySchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    status: Yup.string().required("Required"),
    priority: Yup.string().required("Required"),
});
